$ = jQuery;
require("jquery-match-height-browserify");
var poll_id, poll_answer_id;
jQuery(function () {
    jQuery.support.placeholder = false;
    var test = document.createElement("input");
    if ("placeholder" in test) jQuery.support.placeholder = true;
});

var fitvids = require("fitvids");

$(document).ready(function () {
    initHeader();
    initFooter();
    // initTabs();
    initCycles();
    initSpecialHoverEffects();
    initOutboundLinks();
    initViewAdjustments();
    initExpandables();
    initMxForms();
    initForms();
    initTips();
    initQuestionForms();
    initVariousTweaks();
    initSort();
    initSurvey();
    stickyResourceToolbar();
    pharmacistsTabFilter();

    tabsV2();
    noBarBeforeTabs();

    if (location.hash) {
        setTimeout(function () {
            window.scrollTo(0, 0);
        }, 1);
        setTimeout(function () {
            scrollToOrder();
        }, 50);
    }

    openTabFromLink();

    fitvids(".basic-text");

    $.fn.matchHeight._maintainScroll = true;
    $(".match-height").matchHeight({
        // options
    });

    $(".lightbox").magnificPopup({
        type: "image"
    });

    // setup partner link
    if ($(".intro_with_grey_boxes .partner").length) {
        if ($(".intro_with_grey_boxes .partner .logo a").length == 0) {
            if ($(".intro_with_grey_boxes .partner .info .btn").length) {
                var target = $(".intro_with_grey_boxes .partner .info .btn").attr(
                    "href"
                );
                $(".intro_with_grey_boxes .partner .logo img").wrap(
                    '<a target="_blank" href="' + target + '"></a>'
                );
            }
        }
    }
});

function initHeader() {
    $(".mobile-toggle").on("touchstart click", function (e) {
        e.preventDefault();
        $("#pri-nav").toggleClass("active");
    });

    $(".search-toggle").on("touchstart click", function (e) {
        e.preventDefault();
        $(".search-form").toggleClass("active");
        $(".search-form input").trigger("focus");
    });
}

function initVariousTweaks() {
    $('.column h4 a:contains("Battling the Over-The-Counter High")').html(
        "Battling<br/>the Over-The-Counter High"
    );
}

function initTips() {
    if ($(".tip").length) {
        $(".tip").each(function () {
            var tip = $(this);
            tip.attr("original-title", tip.attr("data-original-title"));
            if ("ontouchstart" in document.documentElement) {
                tip.tipsy({
                    gravity: "n",
                    opacity: 1,
                    html: true,
                    trigger: "manual"
                });
                tip.on("touchend", function (e) {
                    e.preventDefault();
                    if ($(this).hasClass("open")) {
                        $(this).removeClass("open");
                        tip.tipsy("hide");
                    } else {
                        $(this).addClass("open");
                        tip.tipsy("show");
                    }
                });
            } else {
                tip.tipsy({
                    gravity: "n",
                    opacity: 1,
                    html: true
                });
            }
        });
    }
}

function initMxForms() {
    // Form Placeholder support
    if (!$.support.placeholder) {
        $("#mx-form-a02U0000004TRVHIA4 #mx-field-Contact-Email")
            .attr("value", "EMAIL ADDRESS")
            .smartinput();
        $(
                "#mx-form-a02U0000004TRVHIA4 #mx-field-MX_FormSubmission__c-MX_FormSubmission_Message__c"
            )
            .attr("value", "TYPE YOUR MESSAGE HERE")
            .smartinput();
        $("#mx-form-a02U0000004TRVHIA4 .mx-button").val("Send Email");
        $("#mx-form-a02U0000004TRVMIA4 label[for=mx-field-Contact-Email]").html(
            "Quarterly<br />E-Newsletter"
        );
        $("#mx-form-a02U0000004TRVMIA4 #mx-field-Contact-Email")
            .attr("value", "EMAIL ADDRESS")
            .smartinput();
        $("#mx-form-a02U0000004Ts72IAC #mx-field-Contact-LastName")
            .attr("value", "NAME")
            .smartinput();
        $("#mx-form-a02U0000004Ts72IAC #mx-field-Contact-Email")
            .attr("value", "EMAIL ADDRESS")
            .smartinput();
        var active = document.activeElement;
        $(":text")
            .on("focus", function () {
                if (
                    $(this).attr("placeholder") !== "" &&
                    $(this).val() == $(this).attr("placeholder")
                ) {
                    $(this)
                        .val("")
                        .removeClass("hasPlaceholder");
                }
            })
            .on("blur", function () {
                if (
                    $(this).attr("placeholder") !== "" &&
                    ($(this).val() === "" || $(this).val() == $(this).attr("placeholder"))
                ) {
                    $(this)
                        .val($(this).attr("placeholder"))
                        .addClass("hasPlaceholder");
                }
            });
        $(":text").blur();
        $(active).focus();
    } else {
        $("#mx-form-a02U0000004TRVHIA4 #mx-field-Contact-Email").attr(
            "placeholder",
            "EMAIL ADDRESS"
        );
        $(
            "#mx-form-a02U0000004TRVHIA4 #mx-field-MX_FormSubmission__c-MX_FormSubmission_Message__c"
        ).attr("placeholder", "TYPE YOUR MESSAGE HERE");
        $("#mx-form-a02U0000004TRVHIA4 .mx-button").val("Send Email");
        $("#mx-form-a02U0000004TRVMIA4 label[for=mx-field-Contact-Email]").html(
            "Quarterly<br />E-Newsletter"
        );
        $("#mx-form-a02U0000004TRVMIA4 #mx-field-Contact-Email").attr(
            "placeholder",
            "EMAIL ADDRESS"
        );
        $("#mx-form-a02U0000004Ts72IAC #mx-field-Contact-LastName").attr(
            "placeholder",
            "NAME"
        );
        $("#mx-form-a02U0000004Ts72IAC #mx-field-Contact-Email").attr(
            "placeholder",
            "EMAIL ADDRESS"
        );
    }
}

function initForms() {
    var forms = $(".freeform-contact, .newsletter-form");
    if (forms.length && forms.find(".required")) {
        var requiredMessages = {
            email: "Please enter a valid email address",
            EMAIL: "Please enter a valid email address",
            user_message: "Please enter a message"
        };

        function validEmail(text) {
            return text.match(/\S+@\S+\.\S+/);
        }

        forms.submit(function () {
            var valid = true;

            $(this)
                .find(".required")
                .each(function () {
                    var $this = $(this);
                    if (
                        (!$this.val() ||
                            ($this.attr("name") === "email" && !validEmail($this.val())) ||
                            ($this.attr("name") === "EMAIL" && !validEmail($this.val()))) &&
                        requiredMessages[$this.attr("name")]
                    ) {
                        valid = false;
                        alert(requiredMessages[$this.attr("name")]);
                        $this[0].focus();
                        return false;
                    }
                });

            if (!valid) {
                return false;
            }
        });
    }

    $(".orderable-resources .resource-block .btn").on("click", function (e) {
        e.preventDefault();
        // add to resource form
        var resourceId = $(this).attr("data-resource-id"),
            quantity = $(this)
            .parents(".input-wrap")
            .find("input")
            .val();

        // check field for id
        var found = false;
        $('.acf-row:not(.acf-clone) [data-name="resource"]').each(function (
            idx,
            elem
        ) {
            var value = $(elem)
                .find("select")
                .val();
            if (value == resourceId) {
                found = true;
                $(elem)
                    .parents(".acf-row")
                    .find('[data-name="quantity"] input')
                    .val(quantity);
            }
        });
        // if not found, add row
        if (found == false) {
            $('.acf-actions .acf-button[data-event="add-row"]').trigger("click");
            setTimeout(updateNewRowWithData, 500);
        }

        function updateNewRowWithData() {
            $(".acf-row:not(.acf-clone):last")
                .find('[data-name="resource"] select')
                .val(resourceId);
            $(".acf-row:not(.acf-clone):last")
                .find('[data-name="quantity"] input')
                .val(quantity);
        }

        $("html, body").animate({
                scrollTop: $(".order-form .order-details h2").offset().top - 50
            },
            600
        );
    });

    $(".resource-group-toggle").on("click", function (e) {
        e.preventDefault();
        $(this)
            .parents(".resource-group")
            .toggleClass("active");
    });
}

function initExpandables() {
    if ($(".view-more-btn").length) {
        $(".view-more-btn").on("click", function (e) {
            e.preventDefault();
            $(this)
                .parents("li")
                .siblings(".no-show")
                .removeClass("no-show");
            $(this).hide();
        });
    }
}

function initFooter() {
    $("#footer-sec").hoverIntent(
        function () {
            var newHeight =
                $("#footer-sec #social-sites").height() +
                $("#footer-sec #privacy-info").height() +
                126;
            $(this).animate({
                height: newHeight
            }, 250);
        },
        function () {
            $(this).animate({
                height: 86
            }, 250);
        }
    );
}

// function initTabs() {
//   if( $('.tabs').length )
//   {
//     $('.tabs').each(function(){
//       that = $(this);
//       var tabContentContainer = $(this).next('.tab-content-container');
//       $(that).find('li a').click(function(e){
//         e.preventDefault();
//         that.children('.active').removeClass('active');
//         $(this).parent('.tab').addClass('active');
//         tabContentId = $(this).attr('href');
//         tabContentContainer.children('.active').removeClass('active');
//         $(tabContentId).addClass('active');
//       });
//     });
//   }
// }

function initCycles() {
    if ($(".blog-cycle").length) {
        $(".blog-cycle .cycle-entries").each(function () {
            that = $(this);
            that.after('<ul class="blog-entry-pager">');
            that.cycle({
                pager: that.next(".blog-entry-pager"),
                pagerAnchorBuilder: function (idx, slide) {
                    return '<li><a href="#">' + idx + "</li>";
                }
            });
        });
    }
}

function initSpecialHoverEffects() {
    // Next Story bars
    if ($("#next-nav a").length) {
        $("#next-nav").hoverIntent(
            function () {
                $(this).addClass("hovered");
            },
            function () {
                $(this).removeClass("hovered");
            }
        );
        $("#next-nav")
            .not("a")
            .on("click", function (e) {
                window.location = $("#next-nav a").attr("href");
            });
    }
}

function initOutboundLinks() {
    // Any outbound link should open in target=_blank
    $(
        "a[href*='http://']:not([href*='" +
        location.hostname +
        "']),[href*='https://']:not([href*='" +
        location.hostname +
        "'])"
    ).attr("target", "_blank");

    // Any PDF (inbound or outbound) should open in a target=_blank
    $('a[href$=".pdf"]').attr("target", "_blank");
}

function initViewAdjustments() {
    // Stretch and center slangterms box
    if ($(".definition_list_resource").length) {
        // $('.definition_list_resource').each(function(){
        //  that = $(this);
        //  newHeight = that.siblings('.side_list.left').innerHeight()-20;
        //  that.find('.resource-columns').css('height', newHeight);
        //  that.find('.resource-columns ul').vAlign();
        // });
    }
}

function initQuestionForms() {
    if ($(".question").length) {
        $(".full_question form, .question form").submit(function (e) {
            e.preventDefault();
        });
        $(".quiz-answer-btn.Yes, .quiz-answer-btn.No").click(function (e) {
            e.preventDefault();
            form = $(this).parents("form");

            form.append(
                '<input type="hidden" name="option" value="' + $(this).val() + '" />'
            );

            form.ajaxSubmit({
                success: function () {
                    if (form.parents(".full_question").length) size = "full";
                    else size = "half";
                    poll_id = form.find('input[name="poll_id"]').val();
                    response_url =
                        "/_components/question-response/" + size + "/" + poll_id;
                    token = form.find('input[name="csrf_token"]').val();
                    $.post(response_url, {
                        csrf_token: token
                    }, function (r) {
                        if (size == "full") form.parents(".block").html(r);
                        else form.parents(".question").html(r);
                    });
                }
            });
        });
    }
}

function initSort() {
    $(".change-sort").on("change", function () {
        window.location = "/blog/?blog_order=" + $(this).val();
    });
}

function initSurvey() {
    var markup = '<ul class="answers multi">';
    markup +=
        '  <li><input class="quiz-answer-btn Yes" type="image" name="option" value="9" src="/wp-content/themes/sma-theme/assets/images/buttons/Yes-inactive.png" width="64px" height="64px"></li>';
    markup +=
        '  <li><input class="quiz-answer-btn No" type="image" name="option" value="10" src="/wp-content/themes/sma-theme/assets/images/buttons/No-inactive.png" width="64px" height="64px"></li>';
    markup += "</ul>";
    $(".wp-polls-ans").prepend(markup);

    $(".wp-polls-ans .wp-polls-ul").hide();

    // Quiz buttons
    if ($(".answers.two li, .answers.multi li").length) {
        // $('.quiz-answer-btn.Yes').hover(function(){
        //   $(this).attr('src', '/wp-content/themes/sma-theme/assets/images/buttons/Yes-active.png');
        // }, function() {
        //   $(this).attr('src', '/wp-content/themes/sma-theme/assets/images/buttons/Yes-inactive.png');
        // });

        // $('.quiz-answer-btn.No').hover(function(){
        //   $(this).attr('src', '/wp-content/themes/sma-theme/assets/images/buttons/No-active.png');
        // }, function() {
        //   $(this).attr('src', '/wp-content/themes/sma-theme/assets/images/buttons/No-inactive.png');
        // });

        $(".quiz-answer-btn").on("click", function (e) {
            e.preventDefault();
            var pollName = $(this)
                .parents(".wp-polls-ans")
                .find('.wp-polls-ul input[type="radio"]')
                .attr("name"),
                newVal = "";

            if ($(this).hasClass("Yes")) {
                newVal = $(this)
                    .parents(".wp-polls-ans")
                    .find('.wp-polls-ul li:contains("Yes") input')
                    .attr("value");
                $(".quiz-answer-btn.Yes").attr(
                    "src",
                    "/wp-content/themes/sma-theme/assets/images/buttons/Yes-active.png"
                );
                $(".quiz-answer-btn.No").attr(
                    "src",
                    "/wp-content/themes/sma-theme/assets/images/buttons/No-inactive.png"
                );
            }
            if ($(this).hasClass("No")) {
                newVal = $(this)
                    .parents(".wp-polls-ans")
                    .find('.wp-polls-ul li:contains("No") input')
                    .attr("value");
                $(".quiz-answer-btn.No").attr(
                    "src",
                    "/wp-content/themes/sma-theme/assets/images/buttons/No-active.png"
                );
                $(".quiz-answer-btn.Yes").attr(
                    "src",
                    "/wp-content/themes/sma-theme/assets/images/buttons/Yes-inactive.png"
                );
            }

            var radios = $(this)
                .parents(".wp-polls-ans")
                .find('.wp-polls-ul input:radio[name="' + pollName + '"]');
            radios.filter('[value="' + newVal + '"]').prop("checked", true);
        });
    }
}

//Tab functions

function tabsV2() {
    $(".tabs-container a").on("click", function (e) {
        e.preventDefault();

        let tabName = $(this)
            .attr("href")
            .replace(/^#/, "");
        let singleTab = $(this).children(".tab");

        $(".tab").removeClass("active");
        singleTab.addClass("active");

        if (window.innerWidth >= 767) {
            $(".tab-content-container").removeClass("active");
            $("#tab-content-" + tabName).addClass("active");
        } else {
            $(".tabs-content-mobile").removeClass("active");
            $("#tab-content__mobile-" + tabName).addClass("active");
        }
    });
}

// Remove page divider bar if tabs are the siblings

function noBarBeforeTabs() {
    if ($(".tabs").siblings().length) {
        $(".basic-text")
            .find(".bar")
            .css({
                "border-bottom": "none",
                "margin-bottom": "0"
            });
    }
}

function openTabFromLink() {
    let tab = window.location.hash.substr(1);

    if ($(".tabs").length) {
        $(".tabs-container a").each(function (e) {
            let tabID = $(this)
                .attr("href")
                .replace(/^#/, "");
            if (tabID == tab) {
                if (window.innerWidth > 767) {
                    $(this).trigger("click");
                } else {
                    $(this).trigger("click");
                    $("html, body").animate({
                            scrollTop: $(this).offset().top - 100
                        },
                        1000
                    );
                }
            }
        });
    }
}

function scrollToOrder() {
    let tab = window.location.hash.substr(1);
    if ($(".resource-group").length) {
        $(".match-height").each(function () {
            let id = $(this).attr("id");
            if (tab == id) {
                $("html, body").animate({
                        scrollTop: $(this).offset().top - 100
                    },
                    1000
                );
            }
        });
    }
}

// Inits addThis buttons and reinits on filter change

let currentURL = window.location.href;

$(document).on("facetwp-loaded", function () {
    if (window.location.href != currentURL) {
        addthis.layers.refresh();
    }
    currentURL = window.location.href;
});

function stickyResourceToolbar() {
    if (window.innerWidth > 767) {
        $(".resource-section .page-intro").stick_in_parent({
            offset_top: 100,
            spacer: false
        });
        $(".resource-section .filter-bar").stick_in_parent({
            offset_top: 180,
            spacer: false
        });
    } else {
        $(".resource-section .page-intro").trigger("sticky_kit:detach");
        $(".resource-section .filter-bar").trigger("sticky_kit:detach");
    }
}

$(window).resize(function () {
    stickyResourceToolbar();
});

$(".back-button").on("click", function (e) {
    if (history.length > 1) {
        e.preventDefault();
        history.back();
    }
});

$(".fwp-load-more").on("click", function (e) {
    e.preventDefault();

    $(document).on("facetwp-loaded", function () {
        if ($(".filter-bar").hasClass("is_stuck")) {
            $(".resource-section .filter-bar").css({
                position: "fixed",
                bottom: "auto",
                top: "180px"
            });
        }
    });
});

$(document).on("facetwp-loaded", function () {
    if (typeof addthis.layers.refresh !== "undefined") {
        addthis.layers.refresh();
    }
});

// Pre-selects filter when Pharmacists and Retailers tab is clicked
function pharmacistsTabFilter() {
    $(".tabs-container a").each(function () {
        if ($(this).attr("href") == "#pharmacists-retailers" && $(this).attr('href') != window.location.hash) {
            $(this).on("click", function (e) {
                e.preventDefault();
                FWP.reset();
                setTimeout(function () {
                    $('.facetwp-checkbox[data-value="resources-for-retailers"]').trigger(
                        "click"
                    );
                }, 1000);
            });
        } else {
            $(this).on("click", function () {
                FWP.reset();
            });
        }
    });
}